import React, { useState, useEffect } from 'react';
import SearchFilter from './SearchFilter';
import DataTable from './DataTable';
import { Container, Box } from '@mui/material'; // nuevo: Importamos `Box` para estilos adicionales
import { useLocation, useNavigate } from 'react-router-dom';
import Consulta from './Consulta';
import axiosInstancePromise from '../../general/axiosConfig';

const BoxTable = ({table, data, signal}) => {
    const [filteredRows, setFilteredRows] = useState([]);
    const [orderBy, setOrderBy] = useState('');
    const [orderDirection, setOrderDirection] = useState('asc');
    const [refreshKey, setRefreshKey] = useState(0);
    const [hasUpdated, setHasUpdated] = useState(false);
    const navigate = useNavigate();
    const [columns, setColumns] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [selectedField, setSelectedField] = useState('');
    const [fields, setFields] = useState('');
    const [datos, setData] = useState([]);
    const excluir_col = [''];
    const [loading, setLoading] = useState(true);

    const handleSort = (column) => {
      const isAsc = orderBy === column && orderDirection === 'asc';
      setOrderDirection(isAsc ? 'desc' : 'asc');
      setOrderBy(column);
      const sortedRows = [...filteredRows].sort((a, b) => {
        if (isAsc) {
          return a[column] < b[column] ? -1 : 1;
        } else {
          return a[column] > b[column] ? -1 : 1;
        }
      });
      setFilteredRows(sortedRows);
    };

    useEffect(() => {
      setFilteredRows([]);
      setData([]);
      setLoading(true);
      const fetchData = async () => {
        const axiosInstance = await axiosInstancePromise;
        const response = await axiosInstance.get(`/get-table-general/${table}`);
        const allColumns = response.data.columns || [];
        const allRows = response.data.rows || [];
        const filtrarCols = allColumns.filter(column => !excluir_col.includes(column));
        setColumns(filtrarCols);
        setData(allRows);
        setFields(filtrarCols);
        setSelectedField(filtrarCols[0] || '');
        setLoading(false);
      };
      fetchData();
      
    }, [table]);
  
    useEffect(() => {
      if (data.length > 0 && !hasUpdated) {
        setData(data);
        setRefreshKey((prev) => prev + 1);
        setHasUpdated(true);
      } 
    }, [data, hasUpdated]);
    
    useEffect(() => {
      setHasUpdated(false);
    }, [signal]);

    return (
      <Box sx={{display: "flex", justifyContent: "center", overflowX: "auto", }} >
        <Container sx={{ width: "100%", mt: 2, overflowX: "auto", }} >
          <Consulta data={datos} setData={setFilteredRows} columns={columns}/> 
          {!loading ? (<DataTable 
            key={table}
            tabla={table}
            data={filteredRows.length>0? filteredRows:datos}
            searchText={searchText}
            selectedField={selectedField}
            refreshKey={refreshKey}
          />):(<div style={{textAlign:"center", padding:"1rem"}}> Cargando tabla... </div>)
          }
        </Container>
      </Box>
    );
  };
  
export default BoxTable;
